'use client'

import { getCookie } from 'shared/libs/storage/cookie'
import { clsx } from 'shared/libs/style-merge'

import { useEffect, useState } from 'react'

import styles from './SplashScreen.module.scss'

interface Props {
  children: React.ReactNode
}

export default function SplashScreen({ children }: Props) {
  const [showSplash, setShowSplash] = useState(false)
  const [visible, setVisible] = useState(false)
  const [isReady, setIsReady] = useState(false)
  const [isWebview, setIsWebview] = useState<boolean | null>(null)

  useEffect(() => {
    const cookie = getCookie('isWebview')

    if (cookie !== 'true') {
      // Не webview — сразу готово
      setIsWebview(false)
      setIsReady(true)
      return
    }

    setIsWebview(true)

    const alreadySeenSplash = sessionStorage.getItem('hasSeenSplash')
    if (!alreadySeenSplash) {
      sessionStorage.setItem('hasSeenSplash', 'true')
      setShowSplash(true)

      const openTimer = setTimeout(() => setVisible(true), 200)
      const closeTimer = setTimeout(() => {
        setShowSplash(false)
        setIsReady(true)
      }, 600)

      return () => {
        clearTimeout(openTimer)
        clearTimeout(closeTimer)
      }
    } else {
      // Уже показывался
      setIsReady(true)
    }
  }, [])

  // До определения isWebview — ничего не рендерим (чтобы не моргало)
  if (isWebview === null) return null

  // Webview и splash активен — показать splash
  if (isWebview && showSplash) {
    return (
      /* eslint-disable @next/next/no-img-element */
      <div className={styles.container}>
        <img
          src="/static/png/market.png"
          className={styles.logo}
          width={236}
          height={60}
          alt="logo"
        />
        <div className={clsx(styles.makerBlock, { [styles.visible]: visible })}>
          <img
            src="/static/svg/createMdigital.svg"
            alt="kg-flag"
            className={styles.flag}
          />
        </div>
      </div>
    )
  }

  // После splash или если не webview
  return isReady ? <>{children}</> : null
}
